
/* ATTENTION!
This file is automatically generated by scripts/set-env.ts
Please do not change or commit it
*/
import { IEnvironment } from '@skychute/ui-models';
function isEqual(a: any, b: any): boolean {
    return a === b;
}
export const config: IEnvironment = {
    production: isEqual('true', 'true'),
    services: {
        data: {
          endpoint: 'https://demo-hasura.projectre.com.au',
          path: '/v1/graphql',
          logQueries: 'false'
        },
        aws: {
          UserPoolId: 'ap-southeast-2_Xjj0i0S7S',
          AppClientId: '3as2jbsse40ibged5t0624lpus',
          cloudUri: 'https://djpeosbyg3.execute-api.ap-southeast-2.amazonaws.com/dev',
        },
        analytics: {
            segment: {
                enabled: isEqual('false', 'true'),
                writeKey: 'CKazVWLN9swSOQAxq5aOOuUzu9MFuARF',
            },
        },
    },
    application: {
        version: '1.187.1',
        gitHead: '5982acbc2506a67221ea6cc25f3557d048193034',
        branch: 'demo',
        buildDate: 'November 2nd 2026, 10:39:39 pm',
        buildNumber: '1077',
    },
    stripe: {
        publicKey: 'pk_test_51JVQJzICXqe0hIJdVHDRyFoCVJbQwhWPayB7eHg1boYOy7FsCv7Sj1CJSYA2u6vPj4zRNbmsR6tsVu48e0yQEhYT00ycLtgphf'
    },
    addressFinder: {
        key: 'RBHCYUV987D4XKNPT6FL',
        src: 'https://api.addressfinder.io/assets/v3/widget.js'
    },
    courier_push_client_key:'ODM2OTc0NWItODA5NS00OTI3LWE1ZTEtMWI0OGEyZjBkNjg0L3Rlc3Q=',
    recaptcha_v3_site_key:'6LdmFmAsAAAAANaLmdml0XQ_xnImyjlomP8sYP4L',
    novu_push_client_key:'GVO-2E8_6qNx',
    link_private_endpoint:'https://demoprivate.projectre.com.au',
};
